/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DrugUsageUpdateDto
 */
export interface DrugUsageUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof DrugUsageUpdateDto
     */
    'dosageId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrugUsageUpdateDto
     */
    'usageStatus'?: DrugUsageUpdateDtoUsageStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DrugUsageUpdateDtoUsageStatusEnum {
    Done = 'DONE',
    Undone = 'UNDONE',
    Undefined = 'UNDEFINED'
}


